// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2025-04-08 11:38:41 +0200 (Tue, 08 Apr 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 151611 $
//  Purpose   : export dashpanels into dashpanel registry
// =============================================================================
// ---Third-party imports

// ---Framework imports
import log from 'uix/logging'
import {mapItems, get, dict} from 'ldash'

// ---Local Imports
import {panels as P} from './node_overview'

// ---Globals
let _typeCfg = {
  // NodeLinks for pages are only relevant if dconfig.namedEntities=True
  page: {
    NodeTitle: true,
    NodeLinks: true,
    NodeImageViewer: true,
    NodeWebcache: true,
    NodeResources: true,
  },
  metadata: {
    NodeChildren: true,
    NodeLinks: true,
    NodeTitle: true,
    NodeResources: true,
    NodeActivity: true,
    NodeWikiPreview: true,
    NodeUserRelations: true,
  },
  topstructure: {
    NodeChildren: true,
    NodeLinks: true,
    NodeWikiPreview: true,
    NodeActivity: true,
  },
  substructure: {NodeChildren: true, NodeTitle: true, NodeActivity: true, NodeResources: true},
  place: {NodeChildren: true, NodeLinks: true, NodeActivity: true},
  name: {NodeChildren: true, NodeLinks: true, NodeActivity: true},
  subject: {NodeChildren: true, NodeLinks: true, NodeActivity: true},
  deliverer: {NodeChildren: true, NodeLinks: true, NodeUserRelations: true},
  webresource: {UploadDashpanel: true, WebresourceDashpanel: true},
  resource: {},
  code: {},
  folder: {NodeChildren: true},
  container: {NodeChildren: true},
  domain: {
    NodeTranslations: true,
    DomainReleaseHistory: true,
  },
  presentation: {
    NodeChildren: true,
    NodeWikiPreview: true,
    NodeActivity: true,
  },
  workshops: {
    NodeChildren: true,
    NodeWikiPreview: true,
    NodeActivity: true,
    NodeUserRelations: true,
  },
  blogs: {
    NodeChildren: true,
    NodeWikiPreview: true,
    NodeActivity: true,
  },
}

let typeCfg = dict(mapItems(_typeCfg, (dt, v) => [dt, {...v, NodeProperties: true}]))

let get_dts = name => mapItems(typeCfg, (dt, names) => dt, (dt, names) => names[name])

let _order_ = 0
let create = (name, cfg) => {
  _order_ += 1
  return {Comp: P[name] || (({}) => name), order: _order_, datatypes: get_dts(name), ...cfg}
}

export const NodeTitle = create('NodeTitle', {})
export const NodeProperties = create('NodeProperties', {})
export const NodeImageViewer = create('NodeImageViewer', {align: 'right'})
export const NodeResources = create('NodeResources', {align: 'right'})
export const NodeChildren = create('NodeChildren', {align: 'right'})
export const NodeLinks = create('NodeLinks', {align: 'right'})
export const NodeWebcache = create('NodeWebcache', {align: 'right'})
export const NodeActivity = create('NodeActivity', {align: 'right', acl: 'g:admin'})
export const DomainReleaseHistory = create('DomainReleaseHistory', {align: 'right', acl: 'g:admin'})
export const NodeWikiPreview = create('NodeWikiPreview', {align: 'left'})
export const NodeTranslations = create('NodeTranslations', {align: 'right', acl: 'g:debug'})
export const UploadDashpanel = create('UploadDashpanel', {align: 'left', acl: 'g:admin'})
export const WebresourceDashpanel = create('WebresourceDashpanel', {align: 'right', acl: 'g:admin'})
export const NodeUserRelations = create('NodeUserRelations', {align: 'left', acl: 'g:admin'})
